
export var MediaType = {
  "SCREEN_SHARE": 0,
  "AUDIO": 1,
  "VIDEO": 2,
  "WHITE_BOARD": 4
};

export var MediaOper = {
  "STOP_PUBLISH": 0,
  "START_PUBLISH": 1
};

export var RecvState = {
  "STOP_RECV": 0,
  "START_RECV": 1
};

export var AppState = {
  "NONE_STATE": 0,
  "INIT_STATE": 1,
  "LOGIN_STATE": 2,
  "JOIN_STATE": 3
}

export var Graphics = {
  'LINE': 'line',
  'CURVE': 'curve',
  'TEXT': 'text',
  'ERASER': 'eraser',
  'GMOV': 'gmov',
  'PIC': 'pic',
  'POINT': 'point',
  'RECT': 'rect',
  'ROUND_RECT': 'round_rect',
  'ELLIPSE': 'ellipse'
}

export var RecvMagicMode = {
  "FOLLOW": 0,
  "ONLY_ORIGIN": 1,
  "ONLY_MAGIC": 2
}

export var EventResult = {
  "SUCCESS": 0,
  "FAILED": 1,
  "NOADDR": 1001
}

/**
 * @description 异步调用通知事件类型定义
 */
export var EventType = {
  EVENT_INIT                    : "EVENT_INIT",
  EVENT_LOGIN                   : "EVENT_LOGIN",
  EVENT_LOGOUT                  : "EVENT_LOGOUT",
  EVENT_JOIN_GROUP              : "EVENT_JOIN_GROUP",
  EVENT_LEAVE_GROUP             : "EVENT_LEAVE_GROUP",
  EVENT_START_RCV_MEDIA         : "EVENT_START_RECV_MEDIA",
  EVENT_STOP_RCV_MEDIA          : "EVENT_STOP_RECV_MEDIA",
  EVENT_START_PUB_MEDIA         : "EVENT_START_PUB_MEDIA",
  EVENT_STOP_PUB_MEDIA          : "EVENT_STOP_PUB_MEDIA",
  EVENT_GET_ONLINE_USERS        : "EVENT_GET_ONLINE_USERS",
  EVENT_ONLINE_USERS_NOTIFY     : "EVENT_ONLINE_USERS_NOTIFY",
  EVENT_INVITE                  : "EVENT_INVITE",
  EVENT_MAKE_CALL               : "EVENT_MAKE_CALL",
  EVENT_CANCEL_CALL             : "EVENT_CANCEL_CALL",
  EVENT_FINISH_CALL             : "EVENT_FINISH_CALL",
  EVENT_NOTICE_IGNORE_INVITE    : "EVENT_NOTICE_IGNORE_INVITE",
  EVENT_REPLY_INVITE            : "EVENT_REPLY_INVITE",
  EVENT_CANCEL_INVITE           : "EVENT_CANCEL_INVITE",
  EVENT_NOTICE_CANCEL_INVITE    : "EVENT_NOTICE_CANCEL_INVITE",
  EVENT_CREATE_WHITE_BOARD      : "EVENT_CREATE_WHITE_BOARD",
  EVENT_CLOSE_WHITE_BOARD       : "EVENT_CLOSE_WHITE_BOARD",
  EVENT_GET_IMG_URL             : "EVENT_GET_IMG_URL"
}

/**
 * @description 外部可见的通知事件定义
 */
export var PubEventType = {
  PUB_EVENT_SCREEN_SHARE_STOPPED : "onScreenShareStopped",
  PUB_EVENT_GROUP_USER_LIST      : "onGroupUserList",
  PUB_EVENT_USER_JOIN_GROUP      : "onUserJoinGroup",
  PUB_EVENT_USER_LEAVE_GROUP     : "onUserLeaveGroup",
  PUB_EVENT_PUBLISH_MEDIA        : "onPublishMedia",
  PUB_EVENT_UNPUBLISH_MEDIA      : "onUnPublishMedia",
  PUB_EVENT_REMOTE_MEDIA_ADD     : "onRemoteMediaAdd",
  PUB_EVENT_COMMING_INVITE       : "onCommingInvite",
  PUB_EVENT_INVITE_REPLY         : "onInviteReply",
  PUB_EVENT_ONLINE_USER_STATE    : "onOnlineUserState",
  PUB_EVENT_RECV_USER_MSG        : "onRecvUserMsg",
  PUB_EVENT_RECV_GROUP_MSG       : "onRecvGroupMsg",
  PUB_EVENT_GET_STREAM_FAILED    : "onGetStreamFailed",
  PUB_EVENT_ERROR                : "onError"
}

export var DisplayMode = {
  DBWZ: 1,
  DBSY: 2,
  DBSF: 3
}

export var Protocol = {
  HEART: 99999
}
// 线类型
export const lineShape = {
  SOLID: 0,
  SPLIT: 1,
  DOT: 2,
  ONEDOT: 3,
  TWODOT: 4

};
// 填充样式
export const fillStyle = {
  SOLID: 0, //实心填充
  L_SLASH: 1, // 左斜线
  GRID: 2, //网格
  IN_GRID: 3, // 斜网格
  R_SLASH: 4, // 右斜线
  VERTICAL: 6, // 竖线
  HORIZONTAL: 5
};
// 填充模式
export const fillMode = {
  EMPTY: 0,
  FILL_WITH_BORDER: 1, // 填充带边框
  FILL_NO_BORDER: 2 // 填充不带边框
}